import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const BackButtonContainer = styled.div`
  background: ${(props) => props.theme.colors.White};
  border-radius: 4px;
  border: 1px solid #E1E4EA;
  color: #525866;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.084px;
  line-height: 20px;
  padding: 6px 10px 6px 4px;
  position: relative;
  transition: background 300ms ease-in-out;
  z-index: 2;

  &:hover {
    background: #F9FAFB;
  }
`;

const BackIcon = styled.img`
  margin-right: 6px;
`;

const BackButtonLocations = new Set([
  '/onboarding/payment-schedule',
  '/onboarding/demo-payment-schedule',
  '/onboarding/pay-on-approval',
  '/onboarding/net-30-payment-schedule',
  '/onboarding/auto-get-paid-now',
  '/onboarding/on-demand-schedule',
  '/onboarding/bank-info',
  '/onboarding/bank-info-selection',
  '/onboarding/data-sharing-agreement',
  '/onboarding/direct-debit-agreement',
  '/onboarding/acknowledge-direct-debit-agreement',
  '/onboarding/terms',
  '/onboarding/jll-terms',
  '/onboarding/partner-service-agreement',
]);

function BackButton() {
  const navigate = useNavigate();
  const location = useLocation();

  const showBackButton = useMemo(() => BackButtonLocations.has(location.pathname), [location]);

  if (!showBackButton) {
    return null;
  }

  return (
    <BackButtonContainer onClick={() => navigate(-1)}>
      <BackIcon src="/assets/back-icon.svg" />
      Back
    </BackButtonContainer>
  );
}

export default BackButton;
